import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './components/Login';
import { Dashboard } from './components/Dashboard';
import { APRTracker } from './components/APRTracker';
import { MyPositions } from './components/MyPositions';
import { SickleTest } from './components/SickleTest';
import { UserManagement } from './components/UserManagement';
import { UserAccount } from './components/UserAccount';
import { UserLogins } from './components/UserLogins';
import { Profile } from './components/Profile';
import './styles/global.css';

const queryClient = new QueryClient();

function AppRoutes() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />}
      />
      <Route
        path="/"
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/positions"
        element={
          <ProtectedRoute>
            <Layout>
              <MyPositions />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/positions-test"
        element={
          <ProtectedRoute>
            <Layout>
              <MyPositions />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tracker"
        element={
          <ProtectedRoute>
            <Layout>
              <APRTracker />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute requireAdmin>
            <Layout>
              <UserManagement />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/account"
        element={
          <ProtectedRoute requireAdmin>
            <Layout>
              <UserAccount />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/user-logins"
        element={
          <ProtectedRoute requireAdmin>
            <Layout>
              <UserLogins />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Layout>
              <Profile />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sickle-test"
        element={
          <ProtectedRoute>
            <Layout>
              <SickleTest />
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
